import { render } from "./card-info.vue?vue&type=template&id=ed53e0a6&lang=pug"
import script from "./card-info.vue?vue&type=script&lang=js"
export * from "./card-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__